module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector",
    class: ['selector-' + _vm.size, 'selector-' + _vm.theme, _vm.underline != '' ? 'selector-underline' : '']
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title != ''),
      expression: "title!=''"
    }],
    staticClass: "selector-title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "selector-list",
    style: (_vm.listHeight)
  }, [_vm._l((_vm.options), function(item) {
    return _c('li', {
      class: [item.value == _vm.value ? 'selected' : ''],
      on: {
        "click": function($event) {
          _vm.handleClick(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66d6b755!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selector/selector.vue
// module id = 36
// module chunks = 1 4 16